import React from 'react';
import { useSelector } from 'react-redux';

import { CMSContext } from '@swf/cms';

import { select } from '../store';

const CMSProvider: React.FC = ({ children }) => {
  const content = useSelector(select.cms.getContent);
  return <CMSContext.Provider value={content}>{children}</CMSContext.Provider>;
};

export default CMSProvider;
